import script from "./TotalBalanceCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TotalBalanceCard.vue?vue&type=script&setup=true&lang=ts"

import "./TotalBalanceCard.vue?vue&type=style&index=0&id=22eb23ac&scoped=true&lang=postcss"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22eb23ac"]])

export default __exports__